export enum OffersActionTypes {
  reloadResults = 'RELOAD_RESULTS',
  propagateResponse = 'PROPAGATE_RESPONSE',
  filterOffers = 'FILTER_OFFERS',
  setDetailedOffer = 'SET_DETAILED_OFFER',
  setOrderType = 'SET_ORDER_TYPE',
  setFilters = 'SET_FILTERS',
  resetState = 'RESET_STATE',
}
